import { Question  } from '../models/question';

/**
 * Bot service
 *
 * Overview: Provides Bot related services
 *
 */

export class BotService {
    constructor() {
    }

    /**
     * Calls bot API to ask question.
     * @param botAuthorizationEndpointKey API authorization key
     * @param question Model housing bot question API model
     * @param episodeKey The episode key for the question
     * @param metaTagValue The metaTagValue from the configuration
     * @returns Status 200 if returned
     */
    askQuestion(botAuthorizationEndpointKey: string, question: Question, episodeKey: string, metaTagValue: string) {
        console.log("botAuthorizationEndpointKey: ", botAuthorizationEndpointKey);

        return new Promise((resolve, reject) => {
            fetch('https://chathak.netlify.app/api/qa', {
                method: 'POST',
                body: JSON.stringify({ 
                    question: question.question, 
                    episode: "episode:" + episodeKey, 
                    cta: true,
                    game: metaTagValue.toUpperCase()
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': botAuthorizationEndpointKey
                }
            }).then((response) => {
                if (response.ok) {
                    return resolve(response);
                } else {
                    return reject(response);
                }
            }).catch(e => {
                console.log(e);
                return reject(e);
            });
        });
    }
}
